/* ==========================================================================
   MT — Interacciones · vanilla JS, sin librerías
   ========================================================================== */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Reveals al hacer scroll (un solo observer compartido) ---- */
  function initReveals() {
    var els = document.querySelectorAll('.mt-reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('mt-visible'); });
      return;
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('mt-visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (el) { obs.observe(el); });
  }

  /* ---- Cifras animadas (count-up) ----
     El HTML ya trae el valor REAL (nunca "0" si el JS no corre). Solo si vamos
     a animar lo ponemos a 0 y contamos hacia arriba. Si el observer no llega a
     dispararse (móviles con scroll raro), un temporizador de respaldo revela el
     número igualmente para que jamás quede en cero. */
  function initCounters() {
    var nums = document.querySelectorAll('[data-mt-count]');
    if (!nums.length) return;
    function finalOf(el) {
      var target = parseFloat(el.getAttribute('data-mt-count'));
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var dec = (target % 1 !== 0) ? 1 : 0;
      return target.toFixed(dec) + suffix;
    }
    if (reduce || !('IntersectionObserver' in window)) {
      nums.forEach(function (n) { n.textContent = finalOf(n); });
      return;
    }
    function animate(el) {
      if (el.dataset.mtDone) return;
      el.dataset.mtDone = '1';
      var target = parseFloat(el.getAttribute('data-mt-count'));
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var dec = (target % 1 !== 0) ? 1 : 0;
      var start = null, dur = 1400;
      function step(ts) {
        if (start === null) start = ts;
        var p = Math.min((ts - start) / dur, 1);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (target * eased).toFixed(dec) + suffix;
        if (p < 1) requestAnimationFrame(step);
        else el.textContent = target.toFixed(dec) + suffix;
      }
      requestAnimationFrame(step);
    }
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { obs.unobserve(e.target); animate(e.target); } });
    }, { threshold: 0.25, rootMargin: '0px 0px -5% 0px' });
    /* El valor real ya está en el HTML; NO lo tocamos hasta que la cifra entre en
       pantalla (así nunca se ve un "0" si el observer no llega a dispararse). Al
       entrar, animate() resetea a 0 y cuenta hacia arriba. */
    nums.forEach(function (n) { obs.observe(n); });
    /* Respaldo: a los 3,5 s cualquier cifra sin animar se escribe DIRECTAMENTE
       (sin requestAnimationFrame, que puede estar congelado en segundo plano). */
    setTimeout(function () {
      nums.forEach(function (n) { if (!n.dataset.mtDone) { n.dataset.mtDone = '1'; obs.unobserve(n); n.textContent = finalOf(n); } });
    }, 3500);
  }

  /* ---- Acordeón FAQ ---- */
  function initAccordion() {
    var accs = document.querySelectorAll('.mt-acc');
    if (!accs.length) return;
    accs.forEach(function (acc) {
      var q = acc.querySelector('.mt-acc__q');
      var a = acc.querySelector('.mt-acc__a');
      if (!q || !a) return;
      q.addEventListener('click', function () {
        var open = acc.classList.contains('is-open');
        acc.classList.toggle('is-open');
        q.setAttribute('aria-expanded', open ? 'false' : 'true');
        a.style.maxHeight = open ? '0px' : (a.scrollHeight + 'px');
      });
    });
    window.addEventListener('resize', function () {
      document.querySelectorAll('.mt-acc.is-open .mt-acc__a').forEach(function (a) {
        a.style.maxHeight = a.scrollHeight + 'px';
      });
    });
  }

  /* ---- Carrusel de reseñas ---- */
  function initCarousel() {
    var wraps = document.querySelectorAll('[data-mt-carousel]');
    if (!wraps.length) return;
    wraps.forEach(function (wrap) {
      var track = wrap.querySelector('.mt-res__track');
      var prev = wrap.querySelector('[data-mt-prev]');
      var next = wrap.querySelector('[data-mt-next]');
      if (!track) return;
      var index = 0;
      function slidesPerView() {
        var w = window.innerWidth;
        if (w < 640) return 1;
        if (w < 1000) return 2;
        return 3;
      }
      function maxIndex() {
        return Math.max(0, track.children.length - slidesPerView());
      }
      function go() {
        index = Math.max(0, Math.min(index, maxIndex()));
        var card = track.children[0];
        if (!card) return;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 24) || 24;
        var step = card.getBoundingClientRect().width + gap;
        track.style.transform = 'translateX(' + (-index * step) + 'px)';
      }
      if (next) next.addEventListener('click', function () { index++; go(); });
      if (prev) prev.addEventListener('click', function () { index--; go(); });
      window.addEventListener('resize', go);
      go();
    });
  }

  /* ---- Galería de producto ---- */
  function initGallery() {
    var g = document.querySelector('[data-mt-gallery]');
    if (!g) return;
    var mainImg = g.querySelector('[data-mt-gallery-main]');
    var thumbs = g.querySelectorAll('[data-mt-gallery-thumb]');
    if (!mainImg || !thumbs.length) return;
    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var full = t.getAttribute('data-full');
        if (full && mainImg.src.indexOf(full) === -1) {
          /* Fundido suave: precarga la foto y cámbiala sin parpadeo */
          mainImg.classList.add('is-fading');
          var pre = new Image();
          pre.onload = pre.onerror = function () {
            mainImg.src = full;
            mainImg.classList.remove('is-fading');
          };
          pre.src = full;
        }
        thumbs.forEach(function (x) { x.classList.remove('is-active'); });
        t.classList.add('is-active');
      });
    });
  }

  /* ---- Variantes de producto ---- */
  function initVariants() {
    var root = document.querySelector('[data-mt-variants]');
    if (!root) return;
    var dataEl = document.querySelector('[data-mt-variant-json]');
    if (!dataEl) return;
    var variants;
    try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var idInput = root.querySelector('[data-mt-variant-id]');
    var priceNow = root.querySelector('[data-mt-price-now]');
    var priceOld = root.querySelector('[data-mt-price-old]');
    var addBtn = root.querySelector('[data-mt-add]');
    var soldout = root.querySelector('[data-mt-soldout]');
    var selected = {};

    function money(cents) {
      // Formato simple con separador de miles; el símbolo lo hereda del tema
      var v = (cents / 100);
      return v.toLocaleString('es-CO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }
    function match() {
      return variants.find(function (v) {
        return v.options.every(function (opt, i) { return selected[i] === opt; });
      });
    }
    function update() {
      var v = match();
      if (!v) return;
      if (idInput) idInput.value = v.id;
      if (priceNow) priceNow.textContent = (window.MT_CURRENCY || '') + money(v.price);
      if (priceOld) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceOld.textContent = (window.MT_CURRENCY || '') + money(v.compare_at_price);
          priceOld.style.display = '';
        } else { priceOld.style.display = 'none'; }
      }
      if (v.available) {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = addBtn.getAttribute('data-label') || 'Añadir al carrito'; }
        if (soldout) soldout.style.display = 'none';
      } else {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Agotado'; }
        if (soldout) soldout.style.display = '';
      }
    }
    root.querySelectorAll('[data-mt-opt-index]').forEach(function (group) {
      var idx = parseInt(group.getAttribute('data-mt-opt-index'), 10);
      var vals = group.querySelectorAll('.mt-pdp__opt-val');
      vals.forEach(function (b) {
        if (b.classList.contains('is-active')) selected[idx] = b.getAttribute('data-value');
        b.addEventListener('click', function () {
          vals.forEach(function (x) { x.classList.remove('is-active'); });
          b.classList.add('is-active');
          selected[idx] = b.getAttribute('data-value');
          update();
        });
      });
    });
    update();
  }

  /* ---- Muro de reseñas con foto (auto-scroll infinito) ---- */
  function initVReviews() {
    var sliders = document.querySelectorAll('[data-nv-vmarquee]');
    if (!sliders.length) return;
    sliders.forEach(function (slider) {
      var track = slider.querySelector('[data-nv-vtrack]');
      if (!track) return;
      if (!track.dataset.duped) { track.innerHTML += track.innerHTML; track.dataset.duped = '1'; }
      var pos = 0, speed = 40, last = performance.now(), half = 0;
      var hovering = false, dragging = false, startX = 0, startPos = 0;

      function measure() { half = track.scrollWidth / 2; }
      requestAnimationFrame(measure);
      track.querySelectorAll('img').forEach(function (img) {
        if (!img.complete) img.addEventListener('load', measure, { once: true });
      });
      window.addEventListener('resize', measure);
      document.addEventListener('visibilitychange', function () { last = performance.now(); });

      function wrap() { if (half > 0) { while (pos <= -half) pos += half; while (pos > 0) pos -= half; } }
      function apply() { track.style.transform = 'translateX(' + pos + 'px)'; }

      slider.addEventListener('mouseenter', function () { hovering = true; });
      slider.addEventListener('mouseleave', function () { hovering = false; });

      function pointX(e) { return (e.touches && e.touches[0]) ? e.touches[0].clientX : e.clientX; }
      function onMove(e) { if (!dragging) return; pos = startPos + (pointX(e) - startX); wrap(); apply(); }
      function onUp() {
        if (!dragging) return;
        dragging = false; last = performance.now();
        slider.classList.remove('is-grabbing');
        window.removeEventListener('pointermove', onMove);
        window.removeEventListener('pointerup', onUp);
        window.removeEventListener('pointercancel', onUp);
      }
      function onDown(e) {
        dragging = true; startX = pointX(e); startPos = pos; last = performance.now();
        slider.classList.add('is-grabbing');
        window.addEventListener('pointermove', onMove);
        window.addEventListener('pointerup', onUp);
        window.addEventListener('pointercancel', onUp);
      }
      slider.addEventListener('pointerdown', onDown);

      if (reduce) { apply(); return; }
      function loop(now) {
        var dt = (now - last) / 1000; last = now;
        if (!hovering && !dragging && half > 0) { pos -= speed * dt; wrap(); apply(); }
        requestAnimationFrame(loop);
      }
      requestAnimationFrame(loop);
    });
  }

  /* ---- Carrusel con scroll nativo + flechas (deslizable con el dedo) ---- */
  function initScrollCarousel() {
    var roots = document.querySelectorAll('[data-nv-scroll]');
    if (!roots.length) return;
    roots.forEach(function (root) {
      var track = root.querySelector('[data-nv-scroll-track]');
      if (!track) return;
      var prev = root.querySelector('[data-nv-scroll-prev]');
      var next = root.querySelector('[data-nv-scroll-next]');
      function step() {
        var c = track.children[0];
        if (!c) return 300;
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 16) || 16;
        return c.getBoundingClientRect().width + gap;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: reduce ? 'auto' : 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: reduce ? 'auto' : 'smooth' }); });
    });
  }

  /* ---- Prueba social rotativa (hero producto) ----
     Mensajes definidos en la sección (uno por línea); {min} = minutos al azar. */
  function initSocialProof() {
    var t = document.querySelector('[data-nv-social]');
    if (!t) return;
    var msgs = (t.getAttribute('data-msgs') || '').split(/\r?\n/).map(function (s) { return s.trim(); }).filter(Boolean);
    if (!msgs.length) return;
    for (var i = msgs.length - 1; i > 0; i--) { var j = Math.floor(Math.random() * (i + 1)); var x = msgs[i]; msgs[i] = msgs[j]; msgs[j] = x; }
    var k = 1;
    function fmt(s) { return s.replace(/\{min\}/g, 2 + Math.floor(Math.random() * 16)); }
    t.textContent = fmt(msgs[0]);
    if (msgs.length > 1 && !reduce) {
      setInterval(function () {
        t.style.opacity = 0;
        setTimeout(function () { t.textContent = fmt(msgs[k % msgs.length]); k++; t.style.opacity = 1; }, 420);
      }, 7000);
    }
  }

  /* ---- Stock dinámico natural ----
     Toda la configuración vive en la sección "NV – Hero producto" (editor) y llega
     por data-atributos: stock inicial, mínimo, intervalo entre bajadas (min/max, en
     minutos) y unidades por bajada (min/max). Reglas: nunca sube, nunca se
     reinicia, respeta el mínimo. Persistente por visitante (localStorage). */
  function initStock() {
    var el = document.querySelector('[data-nv-stock]');
    if (!el) return;
    var tpl = el.getAttribute('data-tpl') || '';
    if (tpl.indexOf('{n}') === -1) { el.textContent = tpl; return; }
    function num(a, d) { var v = parseInt(el.getAttribute(a), 10); return isNaN(v) ? d : v; }
    var cfg = {
      initial: num('data-initial', 35),
      min:     num('data-min', 6),
      intMin:  num('data-int-min', 3) * 60000,
      intMax:  num('data-int-max', 5) * 60000,
      redMin:  num('data-red-min', 1),
      redMax:  num('data-red-max', 3)
    };
    if (cfg.intMax < cfg.intMin) cfg.intMax = cfg.intMin;
    if (cfg.redMax < cfg.redMin) cfg.redMax = cfg.redMin;
    var KEY = 'nv_stock_v2';
    function rnd(a, b) { return a + Math.floor(Math.random() * (b - a + 1)); }
    function save() { try { localStorage.setItem(KEY, JSON.stringify(s)); } catch (e) {} }
    /* El reloj solo corre mientras el visitante está mirando la página: el
       progreso hacia la próxima bajada (rem, en ms) se guarda entre visitas.
       Así quien vuelve retoma donde iba (nunca sube, nunca se reinicia). */
    var s = null;
    try { s = JSON.parse(localStorage.getItem(KEY)); } catch (e) {}
    if (!s || typeof s.n !== 'number') {
      var start = cfg.initial;
      /* Migración del sistema anterior: el número que ya vio el visitante nunca sube */
      try {
        var v1 = JSON.parse(localStorage.getItem('nv_stock_v1'));
        if (v1 && v1.s && v1.t) {
          var old = Math.max(cfg.min, v1.s - Math.floor((Date.now() - v1.t) / 10800000));
          if (old < start) start = old;
        }
        localStorage.removeItem('nv_stock_v1');
      } catch (e) {}
      s = { n: Math.max(cfg.min, start) };
    }
    if (typeof s.rem !== 'number' || s.rem <= 0) s.rem = rnd(cfg.intMin, cfg.intMax);
    delete s.next; /* forma antigua del estado */
    save();
    function render() { el.textContent = tpl.replace('{n}', s.n); }
    render();
    if (s.n <= cfg.min) return;
    var last = Date.now();
    window.addEventListener('pagehide', save);
    var timer = setInterval(function () {
      var now = Date.now();
      var dt = Math.min(now - last, 15000); /* ignora saltos de pestaña en segundo plano */
      last = now;
      if (document.hidden) return;
      s.rem -= dt;
      if (s.rem > 0) return;
      s.n = Math.max(cfg.min, s.n - rnd(cfg.redMin, cfg.redMax));
      s.rem = rnd(cfg.intMin, cfg.intMax);
      save();
      render();
      if (!reduce) { el.classList.remove('nv-stock-drop'); void el.offsetWidth; el.classList.add('nv-stock-drop'); }
      if (s.n <= cfg.min) { clearInterval(timer); }
    }, 5000);
  }

  /* ---- Selector de cantidad (sincronizado con Releasit) ----
     Releasit lee el input oculto [name="quantity"] de la página al abrir su
     formulario (verificado en vivo). El stepper actualiza ese input con el
     setter nativo + eventos (React) y re-sincroniza justo antes de abrir. */
  function initQty() {
    var root = document.querySelector('[data-nv-qty]');
    if (!root) return;
    var minus = root.querySelector('[data-nv-qty-minus]');
    var plus = root.querySelector('[data-nv-qty-plus]');
    var out = root.querySelector('[data-nv-qty-n]');
    if (!minus || !plus || !out) return;
    var max = parseInt(root.getAttribute('data-max'), 10) || 10;
    var n = 1;
    var setVal = null;
    try { setVal = Object.getOwnPropertyDescriptor(window.HTMLInputElement.prototype, 'value').set; } catch (e) {}

    /* Precio que refleja la cantidad. Derivamos el formato (símbolo, separador de
       miles, decimales) del propio precio ya renderizado por Shopify, así el total
       queda idéntico a como la tienda muestra los precios. */
    var priceEls = document.querySelectorAll('[data-nv-price]');
    function buildFmt(el) {
      var unit = parseInt(el.getAttribute('data-unit'), 10);
      var orig = el.textContent.trim();
      var m = orig.match(/[\d.,\s']+/);
      if (!m || isNaN(unit)) return null;
      var numBlock = m[0];
      var prefix = orig.slice(0, m.index);
      var suffix = orig.slice(m.index + numBlock.length);
      var rawDigits = numBlock.replace(/\D/g, '');
      var d = 0;
      for (var t = 0; t <= 3; t++) { if (String(Math.round(unit / 100 * Math.pow(10, t))) === rawDigits) { d = t; break; } }
      var seps = numBlock.replace(/[\d]/g, '');
      var dec = '', thou = '.';
      if (d > 0) { dec = seps.slice(-1); thou = seps.length > 1 ? seps.charAt(0) : (dec === ',' ? '.' : ','); }
      else { thou = seps.charAt(0) || '.'; }
      return { unit: unit, prefix: prefix, suffix: suffix, d: d, dec: dec, thou: thou };
    }
    function money(f, qty) {
      var s = ((f.unit * qty) / 100).toFixed(f.d);
      var parts = s.split('.');
      var intp = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, f.thou);
      return f.prefix + intp + (f.d > 0 ? f.dec + parts[1] : '') + f.suffix;
    }
    function updatePrices() {
      priceEls.forEach(function (el) {
        if (el._fmt === undefined) el._fmt = buildFmt(el);
        if (el._fmt) el.textContent = money(el._fmt, n);
      });
    }

    function syncInputs() {
      document.querySelectorAll('input[name="quantity"]').forEach(function (inp) {
        if (setVal) setVal.call(inp, String(n)); else inp.value = String(n);
        inp.dispatchEvent(new Event('input', { bubbles: true }));
        inp.dispatchEvent(new Event('change', { bubbles: true }));
      });
    }
    function render() {
      out.textContent = n;
      minus.disabled = n <= 1;
      plus.disabled = n >= max;
      syncInputs();
      updatePrices();
    }
    function pop() {
      if (reduce) return;
      out.classList.remove('nv-qty-pop'); void out.offsetWidth; out.classList.add('nv-qty-pop');
    }
    minus.addEventListener('click', function () { if (n > 1) { n--; render(); pop(); } });
    plus.addEventListener('click', function () { if (n < max) { n++; render(); pop(); } });
    /* Antes de que Releasit abra el formulario, re-aplica la cantidad elegida
       (fase captura: corre antes que el handler de la app) */
    document.addEventListener('click', function (e) {
      if (e.target && e.target.closest && e.target.closest('#rsi_buy_now_button, #floatingBuyNowButton')) syncInputs();
    }, true);
    render();
  }

  /* ---- Video de demostración (nv-demo) ----
     Carga diferida: el mp4 solo se descarga al acercarse al viewport; se pausa
     al salir de pantalla (batería/datos). Con "reducir movimiento": sin
     autoplay, se muestran los controles. */
  function initDemoVideo() {
    var vids = document.querySelectorAll('[data-nv-demo-video]');
    if (!vids.length) return;
    vids.forEach(function (v) {
      var src = v.getAttribute('data-src');
      function load() { if (src && !v.src) { v.muted = true; v.src = src; } }
      if (reduce) { load(); v.controls = true; return; }
      if (!('IntersectionObserver' in window)) { load(); if (v.play) v.play().catch(function () {}); return; }
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { load(); v.play().catch(function () {}); }
          else { v.pause(); }
        });
      }, { rootMargin: '200px 0px', threshold: 0.1 });
      obs.observe(v);
    });
  }

  /* ---- Init ---- */
  function boot() {
    initReveals();
    initCounters();
    initAccordion();
    initCarousel();
    initGallery();
    initVariants();
    initVReviews();
    initScrollCarousel();
    initSocialProof();
    initStock();
    initQty();
    initDemoVideo();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else { boot(); }
})();
